export const styles = {
  fixedTable: {
    tableLayout: 'fixed',
  },
};
